import React from 'react';
import {
  Box,
  Spinner,
  Text,
  VStack,
  Progress,
} from '@chakra-ui/react';
import { FiDownload } from 'react-icons/fi';

/**
 * مكون عرض حالة التحميل أثناء استرجاع المسودة
 */
const DraftLoadingIndicator = ({ message = 'جاري تحميل المسودة المحفوظة...', showProgress = false, progress = 0 }) => {
  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg="rgba(0, 0, 0, 0.5)"
      zIndex="9999"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Box
        bg="white"
        p={8}
        borderRadius="lg"
        boxShadow="xl"
        maxW="400px"
        w="90%"
        textAlign="center"
      >
        <VStack spacing={4}>
          <Box
            w="60px"
            h="60px"
            borderRadius="full"
            bg="blue.100"
            color="blue.500"
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontSize="2xl"
            position="relative"
          >
            <FiDownload />
            <Spinner
              position="absolute"
              size="lg"
              color="blue.500"
              thickness="3px"
            />
          </Box>
          
          <VStack spacing={2}>
            <Text fontSize="lg" fontWeight="semibold" color="gray.800">
              {message}
            </Text>
            <Text fontSize="sm" color="gray.600">
              يرجى الانتظار قليلاً...
            </Text>
          </VStack>
          
          {showProgress && (
            <Box w="100%">
              <Progress
                value={progress}
                size="sm"
                colorScheme="blue"
                borderRadius="md"
                hasStripe
                isAnimated
              />
              <Text fontSize="xs" color="gray.500" mt={1}>
                {Math.round(progress)}% مكتمل
              </Text>
            </Box>
          )}
        </VStack>
      </Box>
    </Box>
  );
};

export default DraftLoadingIndicator;
